export default __webpack_public_path__ + "static/media/DDU_Letter.302f5e78.pdf";